import React, { useEffect, useContext } from "react";
import {
    Row,
    Col
} from "reactstrap";
import Carousel from 'react-multi-carousel';


const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 6,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 6,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 3,
    },
};

const logo1 = [
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/atlas-logo-alt.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/China-Southern-Logo.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/Chip Lee.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/coca cola logo.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/concorde logo.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/famous amos logo.png" }
];

const logo2 = [
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/FoodPanda-logo.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/IMDA logo.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/LG_logo_(2015).png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/NEP logo.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/Nordlb-logo.svg.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/Samudera logo.png" }
];

const logo3 = [
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/Shangri-la.jpg" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/SICCI.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/ST Engineering.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/toysrus logo.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/UNDP_logo.svg.png" },
    { image: "https://whisshcontent.s3.ap-southeast-1.amazonaws.com/wmi_logo.jpg" }
];

function OurClient() {
    return (
        <>
            <div class="ml-auto mr-auto text-center col-md-8">
                <h2 class="big-heading">Our Clients</h2>
            </div>
            <div class="container">
                {[1, 2, 3].map((row) => (
                    <Row key={row} style={{ marginTop: "25px" }} className="ml-auto mr-auto">
                        <Col className="ml-auto mr-auto text-center" md="12">
                            <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={false}
                                responsive={responsive}
                                infinite={true}
                                arrows={false}
                                autoPlay={true}
                                autoPlaySpeed={3000}
                                keyBoardControl={true}
                                containerClass="carousel-container"
                                //removeArrowOnDeviceType={["tablet", "mobile"]}
                                dotListClass="custom-dot-list-style"
                            >
                                {(row == 1 ? logo1 : (row == 2 ? logo2 : logo3)).map((item) => (
                                    <div key={item.toString()}>
                                        <div>
                                            <img
                                                style={{ padding: "10px", objectFit: "contain" }}
                                                alt="Clients"
                                                src={item.image}
                                            ></img>
                                        </div>
                                    </div>))}
                            </Carousel>
                        </Col>
                    </Row>))}
            </div>
        </>
    );
}

export default React.memo(OurClient);
